import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import Commercial from "./pages/Commercial";
import CommercialDetail from "./pages/CommercialDetail";
import Exhibitions from "./pages/Exhibitions";
import ExhibitionDetail from "./pages/ExhibitionDetail";
import About from "./pages/About";
import Shop from "./pages/Shop";
import ShopDetail from "./pages/ShopDetail";
import Films from "./pages/Films";
import FilmDetail from "./pages/FilmDetail";
import Contact from "./pages/Contact";
import Cart from "./pages/Cart";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import GoogleAnalytics from "./components/GoogleAnalytics";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import { Toaster } from "./components/ui/sonner";

const PublicShell = ({ children }) => <Layout>{children}</Layout>;

const RoutedApp = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  const routes = (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/projects/:id" element={<ProjectDetail />} />
      <Route path="/commercial" element={<Commercial />} />
      <Route path="/commercial/:id" element={<CommercialDetail />} />
      <Route path="/exhibitions" element={<Exhibitions />} />
      <Route path="/exhibitions/:id" element={<ExhibitionDetail />} />
      <Route path="/films" element={<Films />} />
      <Route path="/films/:id" element={<FilmDetail />} />
      <Route path="/about" element={<About />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/shop/:id" element={<ShopDetail />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    );
  }

  return (
    <>
      <GoogleAnalytics />
      <PublicShell>{routes}</PublicShell>
    </>
  );
};

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <RoutedApp />
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </CartProvider>
    </div>
  );
}

export default App;
